import store from "../../plugins/store";
export default function auth({ next, router }) {
  if (!store.getters["user/isLoggedIn"]) {
    return router.push({ name: "Home" });
  }
  return next();
}
